export const colors = {
  textPrimary: '#000',
  textSecondary: '#00000040',
  textSecondaryHover: '#00000060'
}